import { KitStruct, VideoChapterStruct } from "../../structs/book-publish-edit.struct";

export class AdminBookPublicationRequest {
  idUserAuthor!: number;

  coverAuthorName?: string | null;
  bookTitle?: string | null;
  bookSubtitle?: string | null;
  collectionName?: string | null;
  volumeName?: string | null;
  versionName?: string | null;
  synopsis?: string | null;
  preface?: string | null;

  idPhotoShape?: number | null;
  authorBio?: string | null;

  idPrimaryCategory?: number | null;
  idSecondaryCategory?: number | null;

  listAuthors: string[] = [];

  isbn?: string | null;
  doi?: string | null;

  totalPages: number = 0;
  idBookPrint!: number;

  // ========= NOVO: nomes dos arquivos já enviados =========
  authorPhotoFileName?: string | null;
  frontCoverFileName?: string | null;
  backCoverFileName?: string | null;

  coverForPrintFileName?: string | null;
  bookForPrintFileName?: string | null;
  bookForEbookFileName?: string | null;

  listKitStruct: KitStruct[] = [];
  listVideoChapterStruct: VideoChapterStruct[] = [];

  /** Libera o livro para venda em marketplace (Amazon) assim que os pré-requisitos forem atendidos. */
  isMarketplaceEnabled: boolean = false;
}
